import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ScheduleAMeeting() {
  return <section data-section-id="9859" id="get-your-free-quote" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585875/img/modern_blurry_workspace.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/30 via-zinc-950/80 to-zinc-950" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="mx-auto max-w-3xl space-y-8">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl">
            Ready for a Brighter, More Efficient System?
          </h1>
          
          <p className="mx-auto max-w-2xl text-lg text-zinc-200 sm:text-xl">
            Don't let dust and debris steal your energy. Improve your solar efficiency and keep your panels performing at their absolute best with a professional clean from Power Shine.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="h-14 rounded-full px-10 text-lg font-bold shadow-2xl transition-transform hover:scale-105 bg-primary text-primary-foreground hover:bg-primary/90">
              <Link to="/ContactUsPage">
                Request Your Free Quote
                <ArrowDown className="ml-2 size-5 animate-bounce" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute bottom-0 left-0 z-20 h-32 w-full bg-gradient-to-t from-background to-transparent" />
    </section>;
}